export const SESSION_EXPIRED_LOGIN_MESSAGE_KEY = "partnerup:show-logged-out-message";

export const isUnauthorizedError = (error) => {
	const status = error?.response?.status ?? error?.request?.status;
	return Number(status) === 401;
};

export const markSessionExpiredForNextLogin = () => {
	if (typeof window === "undefined") return;
	window.sessionStorage.setItem(SESSION_EXPIRED_LOGIN_MESSAGE_KEY, "1");
};

export const consumeSessionExpiredLoginMessage = () => {
	if (typeof window === "undefined") return false;
	const shouldShow = window.sessionStorage.getItem(SESSION_EXPIRED_LOGIN_MESSAGE_KEY) === "1";
	if (shouldShow) {
		window.sessionStorage.removeItem(SESSION_EXPIRED_LOGIN_MESSAGE_KEY);
	}
	return shouldShow;
};
